import Axios from "axios";
// import objectToFormdata from "object-to-formdata";

let email_api = `${process.env.VUE_APP_API_HOST || ""}/api/email`;

export default {
  namespaced: true,
  state: {
    all: null,
    error: false,
  },
  mutations: {
    fetchEmail(state, { res }) {
      state.all = res.data;
    },
    setError(state, error) {
      state.error = error;
    },
    sendEmail() {},
  },
  actions: {
    async sendEmail({ commit }, payload) {
      try {
        await Axios.post(email_api, payload).then(() => {
          commit("sendEmail", { payload });
          commit("setError", false);
        });
      } catch (error) {
        commit("setError", true);
        alert("ส่ง email ไม่สำเร็จ");
      }
    },
  },
  getters: {
    getState: (state) => state,
  },
};
